import ImageShowModal from './ImageShowModal';

export default ImageShowModal;
